import request from "@/shared/apis";

const BASE = "timetables";

function sessionSemesterQuery({ sessionId, semesterId } = {}) {
  const pairs = [];
  if (sessionId != null) pairs.push(`sessionId=${sessionId}`);
  if (semesterId != null) pairs.push(`semesterId=${semesterId}`);
  return pairs.length ? `?${pairs.join("&")}` : "";
}

const exam = {
  createScoped: (dto) => request.post(`${BASE}/scoped`, dto),
  autoDraft: (id) => request.post(`${BASE}/${id}/auto-draft`),
  conflicts: (id) => request.get(`${BASE}/${id}/conflicts`),
  recomputeConflicts: (id) => request.post(`${BASE}/${id}/recompute-conflicts`),
  itemSuggestions: (itemId) => request.get(`${BASE}/items/${itemId}/suggestions`),
  publish: (id) => request.post(`${BASE}/${id}/publish`),
  lock: (id) => request.post(`${BASE}/${id}/lock`),
  myExamTimetable: (params) => request.get(`${BASE}/my-exam-timetable${sessionSemesterQuery(params)}`),
  myInvigilationDuties: (params) => request.get(`${BASE}/my-invigilation-duties${sessionSemesterQuery(params)}`),
  // Relative PDF path; the calling component fetches it as a blob via `request`
  // (responseType: 'blob') following the results-module download pattern.
  documentUrl: (id) => `${BASE}/${id}/document`,
};

export default exam;
